import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';

// Containers
import { ShaftSealProductSelectorComponent } from './containers/shaft-seal-product-selector/shaft-seal-product-selector.component';

// Components
import { ShaftSealButtonComponent } from './components/shaft-seal-button/shaft-seal-button.component';
import { ShaftSealProductFormComponent } from './components/shaft-seal-product-form/shaft-seal-product-form.component';

// Services
import { ShaftSealProductSelectorService } from './shaft-seal-product-selector.service';

@NgModule({
  declarations: [
    ShaftSealProductSelectorComponent,
    ShaftSealButtonComponent,
    ShaftSealProductFormComponent
  ],
  imports: [
    CommonModule,
    HttpModule,
    FormsModule
  ],
  exports: [
    ShaftSealProductSelectorComponent
  ],
  providers: [
    ShaftSealProductSelectorService
  ]
})
export class ShaftSealProductSelectorModule {}


// WEBPACK FOOTER //
// ./app/javascript/product_search/app/shaft-seal-product-selector/shaft-seal-product-selector.module.ts